<template>
  <div class="modal sign-modal pass-modal">
    <div class="overlay" @click="$parent.closePassModal" />
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <button class="close" @click="$parent.closePassModal">
              <div class="desc smallest">{{ $t("Close") }}</div>
              <img class="img" src="./../img/close.svg" />
            </button>

            <div class="left">
              <div class="top-text">
                <div class="title title-main">{{ $t("Change password") }}</div>
              </div>
            </div>
            <div class="right">
              <div class="form-fields">
                <div class="form-fields-wrapper">
                  <label class="input-container">
                    <div class="desc">
                      <span class="red">*</span> {{ $t("Current password") }}:
                    </div>
                    <input
                      type="password"
                      :placeholder="$t('Current password')"
                      v-model="curPass"
                    />
                  </label>
                  <label class="input-container">
                    <div class="desc">
                      <span class="red">*</span> {{ $t("New password") }}:
                    </div>
                    <input
                      type="password"
                      :placeholder="$t('New password')"
                      v-model="newPass"
                    />
                  </label>
                  <label class="input-container">
                    <div class="desc">
                      <span class="red">*</span> {{ $t("Confirm password") }}:
                    </div>
                    <input
                      type="password"
                      :placeholder="$t('Confirm password')"
                      v-model="repeatPass"
                    />
                  </label>
                  <div class="cta-container">
                    <button class="button blue small" @click="updatePassword">
                      <span>{{ $t("Change password") }}</span>
                    </button>
                  </div>
                  <transition name="fade">
                    <div
                      v-if="passUpdateSuccessMessaage"
                      class="error-desc desc green"
                    >
                      {{ passUpdateSuccessMessaage }}
                    </div>
                  </transition>
                  <transition name="slide">
                    <div
                      v-if="passUpdateErrorMessaage"
                      class="error-desc desc red"
                    >
                      {{ passUpdateErrorMessaage }}
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  props: [],
  data: function () {
    return {
      curPass: "",
      newPass: "",
      repeatPass: "",
      passUpdateSuccessMessaage: "",
      passUpdateErrorMessaage: "",
    };
  },
  mounted() {},
  methods: {
    updatePassword() {
      let self = this;
      let passwordList = {
        cur_password: this.curPass,
        new_password: this.newPass,
        repeat_password: this.repeatPass,
      };
      this.$http
        .post(process.env.VUE_APP_API + "user/change-password", passwordList)
        .then((res) => {
          if (res.data.status == "OK") {
            this.passUpdateSuccessMessaage = "Success";
            (this.curPass = ""), (this.newPass = ""), (this.repeatPass = "");
            setTimeout(() => {
              self.passUpdateSuccessMessaage = "";
            }, 3000);
          }
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignIn();
          }
          this.passUpdateErrorMessaage = res.response.data.message;
          setTimeout(() => {
            self.passUpdateErrorMessaage = "";
          }, 3000);
        });
    },
  },
};
</script>
